import React from 'react';
import { Form, Header } from 'semantic-ui-react';

const RequireProfessionalRegistration = ({ settings, setSettings }) => (
  <div className="additional-setting">
    <Header>
      Professional registration
      <Header.Subheader>
        Collect registration IDs such as NPI, RPPS, ADELI, INAMI/RIZIV, or BIG
        from healthcare experts in the United States, France, Belgium, and the Netherlands
      </Header.Subheader>
    </Header>
    <Form.Checkbox
      toggle
      label="Require professional registration"
      checked={settings.requiresProfessionalRegistration}
      onChange={(event, { checked }) => setSettings({
        ...settings,
        requiresProfessionalRegistration: checked,
      })}
    />
  </div>
);

export default RequireProfessionalRegistration;
